export default __webpack_public_path__ + "static/metabolic_eng-ed9c5f787d112aeec2ae7c0b1df694b2.png";